import {
  Box,
  Input,
  FormControl,
  FormLabel,
  IconButton,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
  PopoverCloseButton,
} from '@chakra-ui/react';
import { FaInfo } from 'react-icons/fa';

const CollectionUrlForm = ({ newCollectionUrl, setNewCollectionUrl }) => {
  const RenderInfo = () => {
    return (
      <Popover>
        <PopoverTrigger>
          <IconButton
            variant="outline"
            colorScheme="green"
            aria-label="Get Info"
            size="xs"
            icon={<FaInfo boxSize={8} />}
          />
        </PopoverTrigger>
        <PopoverContent>
          <PopoverArrow />
          <PopoverCloseButton />
          <PopoverBody>
            Provide the link to the meta for this collection.
          </PopoverBody>
        </PopoverContent>
      </Popover>
    );
  };
  return (
    <Box style={{ marginBottom: '20px' }}>
      <Box style={{ marginBottom: '20px' }}>
        <FormControl>
          <FormLabel as="legend">
            Collection Url:
            <RenderInfo />
          </FormLabel>

          <Input
            name="nwCollectionUrl"
            value={newCollectionUrl}
            onChange={e => setNewCollectionUrl(e.target.value)}
            placeholder="Collection Url"
            size="sm"
          />
        </FormControl>
      </Box>
    </Box>
  );
};

export default CollectionUrlForm;
